import { NgModule } from '@angular/core';

import { FacultyService } from './faculty.service';
import { QueueService } from './queue.service';
import { RegistrationService } from './registration.service';
import { IssueService } from './issue.service';
import { ProfileService } from './profile.service';
import { TimeTableFixedService } from './time-table-fixed.service';
import { LoginService } from './login.service';
import { UserService } from './user.service';
import { AccountService } from './account.service';
import { Principal } from './principal.service';
import { UserRouteAccessService } from './user-route-access-service';
import { SoftwareInventoryService } from './software-inventory.service';

@NgModule({
    providers: [
        FacultyService,
        IssueService,
        LoginService,
        ProfileService,
        QueueService,
        RegistrationService,
        TimeTableFixedService,
        UserService,
        Principal,
        UserRouteAccessService,
        AccountService,
        SoftwareInventoryService
    ]
})
export class ServiceProviderModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/services/service-provider.module.ts